
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.5 17.78a14.14 14.14 0 00-.23-2.55H18.5v4.83h6.73a5.77 5.77 0 01-2.5 3.78V27h4a12.16 12.16 0 003.73-9.19z","fill":"#4285f4","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M18.5 30a11.92 11.92 0 008.27-3l-4-3.13a7.54 7.54 0 01-11.22-4H7.33v3.23A12.49 12.49 0 0018.5 30z","fill":"#34a853","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M11.51 19.88a7.28 7.28 0 010-4.76v-3.23H7.33a12.5 12.5 0 000 11.22l4.18-3.23z","fill":"#fbbc05","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M18.5 10a6.75 6.75 0 014.78 1.87l3.58-3.58A12 12 0 0018.5 5a12.49 12.49 0 00-11.17 6.89l4.18 3.23a7.44 7.44 0 017-5.15z","fill":"#ea4335","fill-rule":"evenodd"}})])
          )
        }
      }
    